import { Api } from '../api/api';
import { Injectable } from '@angular/core';
import { User } from '../../models/user';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';

@Injectable()
export class AdminManagedUserProvider {
  private url: string = "admin_managed_users";

  constructor(public api: Api) {
  }

  load(): Observable<{ user_id: number, nickname: string }[]> {
    return this.api.get(this.url)
      .map(users => users.map(user => new User(user)));
  }

}



// WEBPACK FOOTER //
// ./src/providers/admin-managed-user/admin-managed-user.ts